import React, { useState } from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { toast } from 'sonner';
import { Download, Copy, CheckCircle } from 'lucide-react';

function CreativePreviewCard({ imageUrl, mode, tier, createdAt }) {
  const [copiedUrl, setCopiedUrl] = useState(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `creative-${mode.toLowerCase()}-${new Date().getTime()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success('Image downloaded');
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(imageUrl);
    setCopiedUrl(true);
    toast.success('URL copied to clipboard');
    setTimeout(() => setCopiedUrl(false), 2000);
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTierLabel = (tierValue) => {
    const labels = {
      draft: 'Draft',
      standard: 'Standard',
      premium: 'Premium'
    };
    return labels[tierValue] || tierValue;
  };

  return (
    <Card className="card overflow-hidden hover:border-white/20 transition-all">
      <CardContent className="p-0">
        <div className="space-y-3">
          {/* Image Container */}
          <div className="relative bg-white/5 aspect-square overflow-hidden rounded-t-lg">
            <img
              src={imageUrl}
              alt="Generated creative"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="px-4 pb-4 space-y-3">
            {/* Badges */}
            <div className="flex gap-2 flex-wrap">
              <span className="px-2 py-1 rounded text-xs font-medium bg-[#00d4aa]/20 text-[#00d4aa]">
                {mode}
              </span>
              <span className="px-2 py-1 rounded text-xs font-medium bg-blue-500/20 text-blue-400">
                {getTierLabel(tier)}
              </span>
            </div>

            {/* Timestamp */}
            <p className="text-xs text-white/40">
              {formatDate(createdAt)}
            </p>

            {/* Buttons */}
            <div className="flex gap-2">
              <Button
                onClick={handleDownload}
                variant="default"
                size="sm"
                className="flex-1 bg-[#00d4aa] hover:bg-[#00e6bb] text-black"
              >
                <Download className="w-4 h-4 mr-1.5" />
                Download
              </Button>
              <Button
                onClick={handleCopyUrl}
                variant="outline"
                size="sm"
                className="flex-1 border-white/10 text-white hover:bg-white/5"
              >
                {copiedUrl ? (
                  <>
                    <CheckCircle className="w-4 h-4 mr-1.5" />
                    Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4 mr-1.5" />
                    Copy URL
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default CreativePreviewCard;
